import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import {
  closeCreateOrUpdateGroupDialog,
  // createGroup,
  handleGroupModalFieldChange,
  updateGroup,
} from '../../actions/contacts/addOrEdit'
import { createGroup } from '../../actions/contacts/groups'
import language from 'utils/vast-languagepack'

const mapStateToProps = state => ({
  modalOpen: state.contacts.createOrUpdateGroupDialogOpen,
  groupSelectedForUpdate: state.contacts.groupSelectedForUpdate,
  groupModalFieldValue: state.contacts.groupModalFieldValue,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeCreateOrUpdateGroupDialog,
  createGroup,
  handleGroupModalFieldChange,
  updateGroup,
}, dispatch)

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  dialogContentStyles: {
    padding: '25px'
  },
})

class CreateOrUpdateGroupDialog extends Component {
  handleDialogClose = () => {
    this.props.closeCreateOrUpdateGroupDialog()
  }

  handleChange = () => event => {
    this.props.handleGroupModalFieldChange(event.target.value)
  }

  handleDialogCloseSave = () => {
    this.props.createGroup(this.props.groupModalFieldValue)
    this.props.closeCreateOrUpdateGroupDialog()
  }

  render() {
    const { groupModalFieldValue, classes } = this.props

    return (
      <Dialog
        open={this.props.modalOpen}
        onClose={this.handleDialogClose}
      >
        <div className={classes.dialogContentStyles}>
    <DialogTitle>{language.contacts.add.createAGroup}</DialogTitle>
          <TextField onChange={this.handleChange()} label={language.contacts.add.labels.groupTitle} fullWidth value={groupModalFieldValue} />
          <Button onClick={this.handleDialogClose} color="secondary" className={classes.button}>
            {language.contacts.add.cancel}
          </Button>
          <Button onClick={this.handleDialogCloseSave} color="secondary" className={classes.button}>
            {language.contacts.add.ok}
          </Button>
        </div>
    </Dialog>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CreateOrUpdateGroupDialog))
